
newProgramController = ($http, $q, $state, ApiUrl, last_id) ->
    'ngInject'

    @data = id: last_id + 1

    @validateId = (id) ->
        $http.get(ApiUrl('program', 'id_used'), params: id: id)
            .then (r) ->
                console.log r.data.used
                if r.data.used
                then return $q.reject(true)
                else return false

    @save = (data) ->
        return $http.post(ApiUrl('program'), data)
            .then (r) ->
                slug = r.data.item.slug
                $state.go('program.info.details', slug: slug)
                return

    return


getLastId = ($http, ApiUrl) ->
    'ngInject'
    return $http.get(ApiUrl('program', 'last_id'))
        .then (r) -> r.data.id


states = ($stateProvider) ->
    'ngInject'

    $stateProvider.state 'newProgram',
        parent: 'basic'
        url: '/program/new'
        permission: 'createProgram'
        templateUrl: 'programs/admin/new'
        controllerAs: 'newProgram'
        controller: newProgramController
        resolve:
            last_id: getLastId

module.config states
